import type { RenderFunction, TooltipPlacement } from 'antd/lib/tooltip';
import { observer } from 'mobx-react-lite';
import type { PropsWithChildren, ReactNode } from 'react';
import { useState } from 'react';

import { Tooltip } from 'src/shared/components/tooltip';

import './overwrite.scss';

type Props = PropsWithChildren<{
  content: ReactNode | RenderFunction;
  placement?: TooltipPlacement;
}>;

export const ChartTooltip = observer(function ChartTooltip({ content, placement, children }: Props) {
  const [keepParent, setIsKeepParent] = useState(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  // Небольшой костыль, чтобы родительский элемент тултипа не удалялся раньше, чем отработает анимация закрытия
  const onVisibleChange = (isOpened: boolean) => {
    if (isOpened) {
      setIsKeepParent(true);

      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
    } else {
      const timer = setTimeout(() => setIsKeepParent(false), 5000);
      setTimer(timer);
    }
  };

  return (
    <Tooltip
      text={content}
      destroyTooltipOnHide={{ keepParent }}
      placement={placement}
      onVisibleChange={onVisibleChange}
    >
      {children}
    </Tooltip>
  );
});
